export const SAVE_OPTION = {
    save: 'save',
    saveClearSelection: 'saveClearSelection'
}
